import React from "react";

const Clipboard = ({
  width = 46,
  height = 46,
}: {
  width?: number;
  height?: number;
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 46 46"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="1" y="1" width="44" height="44" rx="22" fill="white" />
      <rect x="1" y="1" width="44" height="44" rx="22" stroke="#E2E4E9" />
      <path
        d="M27.5004 14V15.8H30.2067C30.6999 15.8 31.1004 16.2005 31.1004 16.6937V31.1063C31.1004 31.5995 30.6999 32 30.2067 32H15.7941C15.3009 32 14.9004 31.5995 14.9004 31.1063V16.6937C14.9004 16.2005 15.3009 15.8 15.7941 15.8H18.5004V14H27.5004ZM18.5004 17.6H16.7004V30.2H29.3004V17.6H27.5004V19.4H18.5004V17.6ZM20.3004 26.6V28.4H18.5004V26.6H20.3004ZM20.3004 23.9V25.7H18.5004V23.9H20.3004ZM20.3004 21.2V23H18.5004V21.2H20.3004ZM25.7004 15.8H20.3004V17.6H25.7004V15.8Z"
        fill="#525866"
      />
    </svg>
  );
};

export default Clipboard;
